import React from 'react';
import {getPrintableImageSource} from "./print-image-utils.js";
const API_URL = import.meta.env.VITE_API_URL;

const PrintImage = ({image, status}) => {
    const src = getPrintableImageSource(image);
    const hasImage = src && status !== "error" && status !== "missing";

    return (
        <td className="max-w-41.5! w-41.5! py-1! px-0! align-top">
            <div className={"max-w-40.75! w-40.75! border border-black table-cell h-40 align-middle text-center"}>
                {hasImage ? (
                    <img
                        className="max-w-40! max-h-40 w-full! object-contain"
                        alt="image"
                        src={src}
                        width={160}
                        height={160}
                        loading="eager"
                        decoding="sync"
                    />
                ) : (
                    <img
                        className="max-w-40! w-full!"
                        alt="image"
                        width={160}
                        height={160}
                        src={`${API_URL}/public/assets/img/sentry.imgnotfound.large.748x480.png`}
                    />
                )}
            </div>
        </td>
    );
};

export default PrintImage;